__turbopack_context__.v({
  "dark": "A5O-ua_dark",
  "inner-circle": "A5O-ua_inner-circle",
  "inner-circle-container": "A5O-ua_inner-circle-container",
  "inner-circle-outline": "A5O-ua_inner-circle-outline",
  "social-links-container": "A5O-ua_social-links-container",
});
